import axios from 'axios';
import qs from 'qs';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';
/**
 * Wrapper for any axios logic
 */
const ApiService = {
  token: null,

  init(BASE_URL) {
    axios.defaults.baseURL = BASE_URL;
    axios.defaults.withCredentials = true;
    axios.defaults.paramsSerializer = (params) =>
      qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true });
  },

  async getAndSetCsrfToken() {
    try {
      const csrfToken = await ApiService.get('/auth/get_csrf_token/');
      const token = csrfToken.data?.token;
      ApiService.token = token;
      axios.defaults.headers.common['X-CSRFToken'] = token;
    } catch (err) {
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.CSRF_TOKEN_LOADING_ERROR, {
        error: err,
      });
    }
  },

  async get(resource) {
    return await axios.get(resource);
  },
};

export default ApiService;
